export function getMissingRequiredFields(classInfo, settings) {
  if (!settings?.enabled) return [];

  const appliesToLesson = settings.applyToAllLessons || (settings.billingTags || []).includes(classInfo?.billingTag);
  if (!appliesToLesson) return [];

  return (settings.fields || []).filter((field) => !classInfo[field]?.trim());
}

export function isClassInfoCanceled(classInfo) {
  const canceled = classInfo?.canceled;
  const canceledByOwner = classInfo?.canceledByOwner;
  const canceledByClient = classInfo?.canceledByClient;
  return canceled || canceledByOwner || canceledByClient;
}

export function isClassInfoCanceledBySomeone(classInfo) {
  const canceledByOwner = classInfo?.canceledByOwner;
  const canceledByClient = classInfo?.canceledByClient;
  return canceledByOwner || canceledByClient;
}
